<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false">Close</v-btn>
    </v-snackbar>
    <StaffNav />
    <v-row dense>
      <v-col cols="12" lg="12" xl="12">
        <v-card class="pa-2" outlined tile height="100%">
          <v-card>
            <v-card-title style="background-color: #2b3990">
              <span class="headline white--text">{{ titleForm }}</span>
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="isFormValid" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <v-menu
                        ref="calendarMenu"
                        v-model="calendarMenu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="newStartDate"
                            label="Start Date *"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[(v) => !!v || 'This field is required']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newStartDate"
                          no-title
                          scrollable
                          @input="calendarMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-menu
                        ref="calendar2Menu"
                        v-model="calendar2Menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="newEndDate"
                            label="End Date *"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="[(v) => !!v || 'This field is required']"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="newEndDate"
                          no-title
                          scrollable
                          @input="calendar2Menu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <v-textarea
                        v-model="newReason"
                        label="Reason for time off *"
                        outlined
                        :rules="[(v) => !!v || 'This field is required']"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        label="Manager *"
                        v-model="newManager"
                        :items="managers"
                        item-text="Name"
                        item-value="Name"
                        :rules="[(v) => !!v || 'This field is required']"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        label="Program *"
                        v-model="newProgram"
                        :items="programs"
                        item-text="Name"
                        item-value="_id"
                        :rules="[(v) => !!v || 'This field is required']"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" v-if="newRequestDate !== ''">
                      <v-text-field
                        label="Date and Time Requested"
                        v-model="newRequestDate"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      v-if="isAdmin && newApproved === ''"
                    >
                      <v-btn @click="approveRequest" class="success"
                        >Approve</v-btn
                      >
                      <v-btn @click="denyRequest" class="error ml-5"
                        >Deny</v-btn
                      >
                    </v-col>

                    <v-col v-if="newApproved === 'Denied'">
                      <v-text-field
                        v-model="newApproved"
                        label="Status"
                        class="Red pa-8"
                        readonly
                      >
                      </v-text-field>
                      <v-textarea
                        v-model="newDeniedReason"
                        label="Reason Request Wasn't Approved *"
                        outlined
                        class="ma-4"
                        :rules="[(v) => !!v || 'This field is required']"
                      ></v-textarea>

                      <v-text-field
                        :label="signedByTitle"
                        v-model="newSignedBy"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col v-if="newApproved === 'Approved'">
                      <v-text-field
                        v-model="newApproved"
                        label="Status"
                        class="Green pa-8"
                        readonly
                      >
                      </v-text-field>

                      <v-text-field
                        :label="signedByTitle"
                        v-model="newSignedBy"
                        readonly
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="white--text"
                color="#259647"
                @click="addTimeOff()"
                :disabled="!isFormValid"
              >
                Save
              </v-btn>
              <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import StaffNav from "../StaffNav.vue";
import Foot from "../Footer.vue";

const url = require("../../client_config/config").url;

export default {
  components: {
    StaffNav,
    Foot,
  },
  data() {
    return {
      headers: [
        {
          text: "Start Date",
          align: "start",
          value: "StartDate",
        },
        { text: "End Date", value: "EndDate" },
        { text: "Date Requested", value: "dateRequested" },
        { text: "Reason", value: "Reason" },
        { text: "Status", value: "Approved" },
        { text: "Signed By", value: "SignedBy" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      isFormValid: false,
      calendarMenu: false,
      calendar2Menu: false,
      role: localStorage.getItem("userRole"),
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      msg: false,
      menu: false,
      signed: false,
      search: "",
      text: "",
      timeOffs: [],
      programs: [],
      managers: [],
      staffID: this.$route.params.employeeID,
      titleForm: "New Time Off Request",
      staff: "",
      timeOffID: "",
      newStartDate: "",
      newEndDate: "",
      newReason: "",
      newProgram: "",
      newManager: "",
      newApproved: "",
      newDeniedReason: "",
      newSignedBy: "",
      signedByTitle: "",
      approved: false,
      denied: false,
      newRequestDate: "",
      editedIndex: -1,
      isAdmin: false,
      isLoading: true,
      newSignedDate: "",
      newSignedUser: "",
    };
  },

  created() {
    this.getPrograms();
    this.getManagers();
    if (
      localStorage.getItem("userRole") === "Administration" ||
      localStorage.getItem("userRole") === "Program Coordinator" ||
      localStorage.getItem("userRole") === "Human Resources" ||
      localStorage.getItem("userRole") === "Client Services Manager" ||
      localStorage.getItem("userRole") === "Program Manager" ||
      localStorage.getItem("userRole") === "Regional Director" ||
      localStorage.getItem("userRole") === "Medical Manager"
    ) {
      this.isAdmin = true;
    }
  },

  methods: {
    initialize() {
      this.timeOffs = [];
    },

    validate() {
      return this.$refs.form.validate();
    },

    validateReset() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.reset();
      }
    },

    getManagers() {
      axios
        .get(`${url}/users`)
        .then((res) => {
          this.managers = res.data.users;
        })
        .catch((error) => {
          this.msg = true;
          this.text = "Error loading managers: " + error.message;
        });
    },

    showAdd() {
      this.titleForm = "New Time Off Request";
      this.resetForm();
    },

    resetForm() {
      this.newStartDate = "";
      this.newEndDate = "";
      this.newReason = "";
      this.newProgram = "";
      this.newManager = "";
      this.newApproved = "";
      this.newDeniedReason = "";
      this.newRequestDate = "";
      this.newSignedBy = "";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    getPrograms() {
      axios
        .get(`${url}/units`)
        .then((res) => {
          this.programs = res.data.units;
        })
        .catch((error) => {
          this.msg = true;
          this.text = "Error loading programs: " + error.message;
        });
    },

    close() {
      this.resetForm();
      this.$router.go(-1);
    },

    addTimeOff() {
      if (!this.$refs.form) {
        this.msg = true;
        this.text = "Form reference not found";
        return;
      }

      if (!this.$refs.form.validate()) {
        this.msg = true;
        this.text = "Please fill out all required fields";
        return;
      }

      const request_body = {
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        Reason: this.newReason,
        Program: this.newProgram,
        Manager: this.newManager,
        Approved: this.newApproved,
        DeniedReason: this.newDeniedReason,
        SignedBy: this.newSignedBy,
        StaffID: this.staffID,
        CreatedDate: new Date(),
        SignedDate: this.newSignedDate,
        SignedUser: this.newSignedUser,
        Url: window.location.href,
      };

      axios
        .post(`${url}/timeOff`, request_body)
        .then((response) => {
          if (response.status === 200) {
            this.msg = true;
            this.text = "The new time off request has been added successfully.";
            this.close();
          }
        })
        .catch((error) => {
          this.msg = true;
          this.text =
            error.response?.data?.msg ||
            "An error occurred while saving the request";
        });
    },

    approveRequest() {
      const now = new Date();
      const isoDateTime = now.toISOString();
      const userName = localStorage.getItem("Name");

      this.newSignedBy = `${userName} ${isoDateTime}`;
      this.newSignedDate = isoDateTime;
      this.newSignedUser = userName;
      this.newApproved = "Approved";
      this.approved = true;
      this.denied = false;
      this.signedByTitle = "Approved By";
    },

    denyRequest() {
      const now = new Date();
      const isoDateTime = now.toISOString();
      const userName = localStorage.getItem("Name");

      this.newApproved = "Denied";
      this.denied = true;
      this.approved = false;
      this.newSignedBy = `${userName} ${isoDateTime}`;
      this.newSignedDate = isoDateTime;
      this.newSignedUser = userName;
      this.signedByTitle = "Denied By";
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}
</style>
